import { useEffect } from 'react'
import { usePrequalRequest } from '../../../../../hooks/usePrequalRequest'
import { useVerificationFlow } from '../../VerificationFlowContext'

export const StartPrequalView = () => {
  const { state, dispatch } = useVerificationFlow()
  const { canSendPrequal } = usePrequalRequest()

  const handleStartPrequal = () => {
    // Start verification for the loan officer
    dispatch({ type: 'START_NEXT_PARTNER_VERIFICATION' })
  }

  const handleSkipPrequal = () => {
    dispatch({ type: 'SKIP_PARTNER_VERIFICATION', payload: { partnerType: 'LoanOfficer' } })
  }

  useEffect(() => {
    // Check if we have a loan officer to receive the prequal
    if ((state.customerIsLoanOfficer || state.loanOfficerMembership) && canSendPrequal) {
      handleStartPrequal()
    } else {
      handleSkipPrequal()
    }
  }, [canSendPrequal, state.loanOfficerMembership])

  return null
}
